/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Vscode_AddInputs */

const en_mcp_vscode_add = /** @type {(inputs: Mcp_Vscode_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run MCP: Open User Configuration from the Command Palette and add this entry to servers.`)
};

const es_mcp_vscode_add = /** @type {(inputs: Mcp_Vscode_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuta MCP: Open User Configuration desde la paleta de comandos y añade esta entrada a servers.`)
};

/**
* | output |
* | --- |
* | "Run MCP: Open User Configuration from the Command Palette and add this entry to servers." |
*
* @param {Mcp_Vscode_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_vscode_add = /** @type {((inputs?: Mcp_Vscode_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Vscode_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_vscode_add(inputs)
	return en_mcp_vscode_add(inputs)
});